import { Injectable } from '@angular/core';
import { Loggable } from '@services/strategy-pattern-login/loggable';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@services/webFeeder/config.service';
import { Login } from '@model/login.model';
import { Constants } from '@utils/constants';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { OmsAdmin } from '@model/recover-password';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { TokenService } from '@services/webFeeder/token.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from '@services/http-service';
import { ChangePassword } from '@model/change-password';
import { RecoverTypeEnum } from '@model/enum/recover-type.enum';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { AppUtils } from '@utils/app.utils';

@Injectable({
  providedIn: 'root'
})
export class Auth2Service implements Loggable {

  public dialog: MatDialog;

  constructor(
    private httpsvc: HttpClient,
    private httpService: HttpService,
    private configService: ConfigService,
    private tokenService: TokenService,
    private workspaceService: WorkspaceNewService,
    dialog: MatDialog) {
    // LoginS
    this.dialog = dialog;
  }

  login(username: string, password: string, profile?: any) {
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + environment.BROKER
    };
    const user = { username: credential.username, firstName: credential.username, lastName: credential.username };
    this.configService.setHbCurrentUser(user);
    const params = JSON.stringify(credential);
    return this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/LoginSignIn', params, Constants.httpOptions);
  }

  loginO(username: string, password: string, profile?: any) {
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + profile
    };
    const user = { username: credential.username, firstName: '', lastName: '' };
    this.configService.setHbCurrentUser(user);
    const params = JSON.stringify(credential);
    return this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/LoginO', params, Constants.httpOptions);
  }

  brokerServiceLogin(username: string, password: string, broker: string) {
    let url = 'services/Authenticate/LoginHomeBroker';
    if (this.configService.isAuthenticationBroker()) {
      url = 'services/AuthFast/LoginSignIn';
    }
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + environment.BROKER
    };
    const params = JSON.stringify(credential);
    return this.httpService
      .doPost(this.configService.getApiWebFeederRest(), url, params)
      // .pipe(
      //   map(res => {
      //     return res;
      //   }),
      //   // catchError((error: any) => [throwError(() => error)])
      // )
    // .catch((error: any) => [Observable.throw(error)]);

  }

  brokerServiceLogout() {
    const token = this.configService.getTokenApi();
    const username = this.configService.getBrokerAccount();
    if (token && username) {
      const credential: any = { username: username };
      const params = JSON.stringify(credential);
      return forkJoin(this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/Authenticate/LogoutHomeBroker', params, Constants.httpOptions),
        this.tokenService.revokeAPIGatewayToken(token),
        this.workspaceService.revokeAPIWorkspacesToken(token)).pipe(
          map(([resp0,]) => {
            return resp0;
          }));
    } else if (token) {
      this.tokenService.revokeAPIGatewayToken(token).subscribe();
      this.workspaceService.revokeAPIWorkspacesToken(token)
        .subscribe(() => {
          return true;
        });
      return true;
    }
    return false;
  }

  brokerServiceInternalLogout() {
    const username = this.configService.getBrokerAccount();
    const credential: any = { username: username };
    const params = JSON.stringify(credential);
    return this.httpsvc
      .post(this.configService.getApiWebFeederRest() + '/services/Authenticate/LogoutHomeBroker', params, Constants.httpOptions)
      .pipe(
        map(res => res),
        catchError((error: any) => [throwError(() => error)])
      )
    // .catch((error: any) => [Observable.throw(error)]);
  }

  changePassword(token: string, type: number, newPassword: string, broker: string, product?: string, recoverType?: string) {
    const credential: OmsAdmin = {
      broker: broker,
      token: token,
      newPassword: newPassword,
    };
    if (product) {
      credential.product = product;
    }
    if (recoverType) {
      credential.recoverType = recoverType;
    }
    const params = JSON.stringify(credential);
    return this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/ChangePassword',
      params, Constants.httpOptions)
      .pipe(
        map(res => {
          return res;
        }),
        catchError((error: any) => [throwError(() => error)])
      )
    // .catch((error: any) => [Observable.throw(error)]);
  }

  recoverPassword(email: string, type: number) {
    const credential: OmsAdmin = {
      broker: this.configService.getBroker(),
      email: email,
      type: type ? type : 2
    };
    const params = JSON.stringify(credential);
    return this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/RecoverPassword',
      params, Constants.httpOptions)
      .pipe(map(res => {
        return res;
      }))
  }

  difusionChangePassword(login: string, oldPassword: string, newPassword: string, isPasswordExpired = false, recoverType?) {
    if (!login) {
      return of([]);
    }
    if (recoverType === RecoverTypeEnum.NEGOTIATION) {
      let params = '';
      const credential: ChangePassword = {
        username: login,
        password: oldPassword,
        newPassword: newPassword,
        clientDocument: '',
        softwareName: '',
        softwareVersion: '',
        ipAdress: ''
      };
      params = JSON.stringify(credential);
      return this.httpService
        .doPost(this.configService.getApiWebFeederRest(), 'services/Authenticate/ChangePasswordHomeBroker', params, false)
        .pipe(map(response => {
          if (response) {
            return response;
          }
          return [];
        }));
    } else {
      if (!isPasswordExpired) {
        const credential: OmsAdmin = {
          login: login,
          oldPassword: oldPassword,
          newPassword: newPassword
        };
        const params = JSON.stringify(credential);
        return this.httpService
          .doPost(this.configService.getApiWebFeederRest(), 'services/AuthFast/difusionChangePassword', params, false)
          .pipe(
            map(res => {
              return res;
            }),
            catchError((error: any) => [throwError(() => error)])
          )
        // .catch((error: any) => [Observable.throw(error)]);
      } else {
        let params = '';
        const credential: ChangePassword = {
          username: login,
          password: oldPassword,
          newPassword: newPassword,
          clientDocument: '',
          softwareName: '',
          softwareVersion: '',
          ipAdress: ''
        };
        params = JSON.stringify(credential);
        return this.httpService
          .doPost(this.configService.getApiWebFeederRest(), 'services/Authenticate/ChangePasswordHomeBroker', params, false)
          .pipe(map(response => {
            if (response) {
              return response;
            }
            return [];
          }));
      }
    }
  }

  clientRegisterSimulator(username: string, password: string) {
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + environment.BROKER
    };
    const wl = this.configService.getConfigWhitelabel();
    if (wl.system.cod === WhitelabelEnum.RANKING) {
      credential.broker = this.configService.getBroker() + 'NEG';
    }
    const params = JSON.stringify(credential);
    return this.httpsvc.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/ClientRegisterSimulator',
      params, Constants.httpOptions)
      .pipe(
        map(res => {
          return res;
        }),
        catchError((error: any) => [throwError(() => error)])
      )
    // .catch((error: any) => [Observable.throw(error)]);
  }

  loginToken(token: string) {
    throw new Error('Method not implemented.');
  }

  isTokenExpired() {
    return new Date() >= AppUtils.strToDateTime(this.configService.getTokenExpiration()) ? true : false;
  }

  refresh() {
    const params: any = {};
    params.refresh_token = this.configService.getTokenRefreshApi();
    return this.httpService.doPost(this.configService.getApiWebFeederRest(), 'services/AuthFast/RefreshToken', JSON.stringify(params));
  }

  resetSignature(signature: string, newSignature: string) {
    throw new Error('Method not implemented.');
  }

  forgotSignature() {
    throw new Error('Method not implemented.');
  }

  advisorInfo(login?: string) {
    throw new Error('Method not implemented.');
  }
  advisorChangePassword(currentPassword: string, newPassword: string, guid?: string, advisorId?: number) {
    throw new Error('Method not implemented.');
  }

  loginAuth(code: string, second_auth_option: string, answer: string, username?: string, password?: string) {
    throw new Error('Method not implemented.');
  }

  loginWS(guidUser?: string) {
    return this.httpService
      .doGet(this.configService.getApiWebFeederRest(), 'services/AuthFast/LoginWS?guidUser=' + guidUser)
      .pipe(map(response => {
        if (response) {
          const json = response;
          return json;
        }
        return [];
      }));
  }

  info() {
    throw new Error('Method not implemented.');
  }

  validateTokenAdapter() {
    throw new Error('Method not implemented.');
  }

}
